rpraFaqData;

;(function ($) {
  let $document = $(document);

  $document.ready(function() {
    //$document.on('click', '.faq-form_submit', faqFilterChange);
    $document.on('submit', '#faq_filters', faqFilterChange);
    $document.on('click', '.faq-form_reset', faqFilterReset);
    $document.on('click', '.copy-faq-to-clipboard', copyFaqToClipboard);
    $document.on('click', '.faq-card_toggle', faqShowHideToggle);
    initFaqShowHideToggle();

    // open all accordions when searching using F3, CTRL+f, or CMD+f
    if($('.faq-card').length) {
      $document.on('keydown', function(e) {
        if(e.keyCode === 114 || (e.ctrlKey && e.keyCode === 70) || (e.metaKey && e.keyCode === 70)) {
          $('.faq-card').addClass('faq-card--open');
          $('.faq-card .faq-card_toggle').attr('aria-expanded', true);
          $('.faq-card .faq-card_content-wrapper').attr('aria-hidden', false);
        }
      });
    }
  });

  /**
   * Reload the page when someone submits a FAQ filter change
   */
  function faqFilterChange(e) {
    e.preventDefault();

    var $this = $(this),
      WP = rpraFaqData,
      program = $('#faq_program_filter').val(),
      audience = $('#faq_audience_filter').val(),
      topic = $('#faq_topic_filter').val(),
      keyword = $('#faq_keyword').val(),
      formData = {},
      queryString,
      url = WP.faq_archive_url;

    if (program != 0 && program != '') {
      formData.faq_program = program;
    }

    if (audience != 0 && audience != '') {
      formData.faq_audience = audience;
    }

    if (topic != 0 && topic != '') {
      formData.faq_topic = topic;
    }

    if (keyword != 0 && keyword != '') {
      formData.faq_keyword = keyword;
    }

    queryString = serializeUrlVars(formData);

    console.log('queryString', queryString);

    if (queryString.length) {
      url = url + '?' + queryString;
    }

    window.location = url;
  }

  /**
   * Reset the form values
   */
  function faqFilterReset(e) {
    e.preventDefault();

    $('#faq_program_filter').prop('selectedIndex',0);
    $('#faq_audience_filter').prop('selectedIndex',0);
    $('#faq_topic_filter').prop('selectedIndex',0);
    $('#faq_keyword').val('');

    $('[data-dropdown-open]').each(function() {
      let dropdown = $(this);

      dropdown.find('li[data-dropdown-selected]').removeAttr('data-dropdown-selected');
      dropdown.find('.dropdown-chip').remove();
      dropdown.find('.counter').hide();
      dropdown.find('.placeholder').show();
      dropdown.find('.selected-options').empty();
    });

    faqFilterChange(e);
  }

  /**
   * Build a query string for use in a URL.
   *
   * @param {type} obj
   * @param {type} prefix
   * @returns {String}
   */
  function serializeUrlVars(obj, prefix) {
    var str = [];
    for (var p in obj) {
      if (obj.hasOwnProperty(p)) {
        var k = prefix ? prefix + "[" + p + "]" : p, v = obj[p];
        str.push(typeof v == "object" ?
          encodeURIComponent(k) + "=" + v.join(',') :
          encodeURIComponent(k) + "=" + encodeURIComponent(v));
      }
    }
    return str.join("&");
  }

  /**
   * Copies the searched URL to keyboard so that when shared and opened it shows the same reuslts with the question open and scrolled down to.
   */
  function copyFaqToClipboard() {
    var $this = $(this),
      text = $this.data('copy-to-clipboard');

    if(window.isSecureContext && navigator.clipboard) {
      navigator.clipboard.writeText(text);
    } else {
      copyToClipboard($this, text);
    }
  }

  function copyToClipboard(el, text) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    el.parent()[0].appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');
    } catch (err) {
      console.error('Unable to copy to clipboard', err);
    }

    el.parent()[0].removeChild(textArea);

    el.focus();
  }

  /**
   * Init the Show/Hide Accordions, Covers NO-JS
   */
  function initFaqShowHideToggle() {
    var faqCards = $('.faq-card');

    faqCards.each(function(i, e) {
      var card = $(this),
        toggle = card.find('.faq-card_toggle'),
        content = card.find('.faq-card_content-wrapper');

      if(card) {
        if(!card.hasClass('faq-card--keep-open')) {
          card.removeClass('faq-card--open');
          toggle.attr('aria-expanded', false);
          content.attr('aria-hidden', true);
        }
      }
    });
  }

  /**
   * Show/Hide Accordion Toggle.
   */
  function faqShowHideToggle() {
    var $this = $(this),
      card = $this.closest('.faq-card'),
      content = card.find('.faq-card_content-wrapper');

    if(card.hasClass('faq-card--open')) {
      card.removeClass('faq-card--open');
      $this.attr('aria-expanded', false);
      content.attr('aria-hidden', true);
    } else {
      card.addClass('faq-card--open');
      $this.attr('aria-expanded', true);
      content.attr('aria-hidden', false);
    }
  }

  /**
   * Paginate FAQs
   */
  $document.on('click', '.faq-content_pagination a', function(e) {
    e.preventDefault();

    var $nextLink = $(this);
    if($nextLink.hasClass('loading')) {
      return false;
    }
    $nextLink.attr('disabled', 'disabled').addClass('disabled').find('.button-text').html('Loading');

    $('<div>').load($nextLink.attr('href') + ' #content', function() {
      var $div = $(this);
      var $cards = $div.find('.faq-card_list > li');
      var $pagination = $div.find('.faq-content_pagination');

      $cards.each(function() {
        var card = $(this).find('.faq-card'),
          toggle = $(this).find('.faq-card_toggle'),
          content = $(this).find('.faq-card_content-wrapper');

        if(card) {
          card.removeClass('faq-card--open');
          toggle.attr('aria-expanded', false);
          content.attr('aria-hidden', true);
        }
      });

      if($pagination.length>0) {
        $('.faq-content_pagination').replaceWith($pagination);
      } else {
        $('.faq-content_pagination').remove();
      }

      $('#content .faq-card_list').append($cards);
    });
  });

  function createNewDropdown(originalSelectTag, index) {
    const id = originalSelectTag.attr("id")
      ? `virtual-${originalSelectTag.attr("id")}`
      : `virtual-select-${index}`;

    const isMultiple = originalSelectTag.attr("multiple");

    $(`#${id}`).remove();

    // Create the dropdown element
    const newDropdownContainer = $(
      `<div>
        <div class="dropdown-item">
          <span class="placeholder"></span>
          ${isMultiple ? `<ul></ul><span class="counter">+1</span>` : ""}
        </div>
        <div class="${(
          `options-container ` +
          `${originalSelectTag.attr("name") === "types" ? `keep-height` : ""}`
        ).trim()}">
          ${
            isMultiple
              ? `
                <ul class="selected-options"></ul>
                <div class="intro-text">Select all that apply</div>
              `
              : ""
          }
          <div class="blank-state">
            <span class="spinner"></span>
            <p>Loading</p>
          </div>
          <ul class="dropdown-options"></ul>
        </div>
      </div>`
    );
    newDropdownContainer.attr("id", id);
    newDropdownContainer.attr("data-dropdown-open", false);
    newDropdownContainer.attr(
      "data-dropdown-name",
      originalSelectTag.attr("name")
    );

    // Grabs the elements we need
    // The element that contails all the dropdown options
    const newDropdownOptions = newDropdownContainer.find("ul.dropdown-options");
    // The place where the selected option will be displayed
    const newDropdownText = newDropdownContainer.find("div.dropdown-item");
    const selectedOptionsContainer = newDropdownContainer.find(
      "ul.selected-options"
    );

    // The initial selected option
    const initialSelectedOption =
      (isMultiple ? undefined : originalSelectTag.find("option:selected")) ||
      originalSelectTag.find("option.placeholder") ||
      originalSelectTag.find("option:first-child");

    let selectedOptions = [];

    createDropdownOptions();
    setupDropdownEvents();
    copyStyles();

    return newDropdownContainer;

    // *******
    // ** Functions
    // *******

    function setupDropdownEvents() {
      function openDropdown(e) {
        e.preventDefault();
        e.stopPropagation();
        closeAllDropdowns();

        // Get the current value of the attribute
        const currentValue = newDropdownContainer.attr("data-dropdown-open");

        // Find elements with the data-dropdown-open attribute
        $("[data-dropdown-open]").each(function () {
          var jQueryelement = $(this);

          // Check if the click event is not within the current element or its descendants
          if (
            !jQueryelement.is(event.target) &&
            jQueryelement.has(event.target).length === 0
          ) {
            // Set the attribute to "false" when clicking outside
            jQueryelement.attr("data-dropdown-open", "false");
          }
        });

        // Toggle between true and false
        const newValue = currentValue === "true" ? "false" : "true";

        // Update the attribute value
        newDropdownContainer.attr("data-dropdown-open", newValue);
      }

      // Open the dropdown when clicking on the selection container
      newDropdownContainer.on("click", openDropdown);
    }

    /**
     * @param {JQuery} item Current working item
     */
    function unselectItem(item) {
      item.removeAttr("data-dropdown-selected");

      const value = item.attr("data-dropdown-value");

      selectedOptions = selectedOptions.filter(
        (selectedItem) => selectedItem !== value
      );

      originalSelectTag.find(`option[value="${value}"]`).prop("selected", false);

      if (isMultiple) {
        selectedOptionsContainer
          .find(`li[data-dropdown-value="${value}"]`)
          .remove();

        newDropdownText.find(`li[data-dropdown-value="${value}"]`).remove();

        if (selectedOptions.length === 1) {
          newDropdownText.find(".counter").hide();
        } else {
          newDropdownText.find(".counter").text(`+${selectedOptions.length - 1}`);
        }

        if (selectedOptions.length === 0) {
          newDropdownText.find(".placeholder").show();
        }
      }
    }

    /**
     * @param {JQuery} item Current working item
     */
    function selectItem(item) {
      const value = item.attr('data-dropdown-value');
      const text = item.find('span').text();

      selectedOptions.push(value);

      if(!isMultiple) {
        const currentSelected = newDropdownOptions.find('[data-dropdown-selected]');

        if(currentSelected && currentSelected.length > 0) {
          // Remove the selected attribute from the previous selected item
          unselectItem(currentSelected);
        }
      } else {
        const chip = $(
          `<li class="dropdown-chip">
            <span class="chip-label">${text}</span>
            <button type="button" id="remove-chip">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.6" d="m12 4-8 8m0-8 8 8"/></svg>
            </button>
            </li>`
        );
        chip.attr("data-dropdown-value", value);

        function onClick(e) {
          e.preventDefault();
          e.stopPropagation();

          toggleItem(item);
        }

        chip.find("#remove-chip").on("click", onClick);

        selectedOptionsContainer.append(chip);

        // If we copy the element we need to re-set the handlers
        const secondChip = chip.clone();
        secondChip.find("#remove-chip").on("click", onClick);

        newDropdownText.find("ul").append(secondChip);

        // If more than one
        if(selectedOptions.length > 1) {
          // Show the counter and update the value
          newDropdownText.find(".counter").text(`+${selectedOptions.length - 1}`).css({ display: 'block' });
        }

        newDropdownText.find(".placeholder").hide();
      }

      // Find the <option> with the current value
      const newSelectedOption = originalSelectTag.find(
        `option[value="${value}"]`
      );

      // Select new item
      newSelectedOption.prop("selected", true);
      item.attr("data-dropdown-selected", true);
    }

    /**
     * @param {JQuery} item Current working item
     */
    function toggleItem(item) {
      const isAlreadySelected = item.attr("data-dropdown-selected") === "true";

      if (isAlreadySelected) {
        unselectItem(item);
      } else {
        selectItem(item);
      }

      if (!isMultiple) {
        // Now that seletion/unselection has taken care of,
        // we can grab the text of the remaining selected option
        // And use it for display
        const selected = originalSelectTag.find("option:selected");
        if (selected && selected.length > 0) {
          if (isMultiple && placeholderItem) {
            newDropdownText.text(placeholderItem.text() + " *");
          } else if (!isMultiple) {
            newDropdownText.text(selected.text());
          }
        } else if (placeholderItem) {
          newDropdownText.text(placeholderItem.text());
        }

        // Close the dropdown
        newDropdownContainer.attr("data-dropdown-open", false);
      }
    }

    function setupDropdownItemEvents(item) {
      function toggleItemEvent(event) {
        // Prevent the default action
        event.preventDefault();
        event.stopPropagation();

        const currentClickedItem = $(this);
        toggleItem(currentClickedItem);
      }

      // If user clicks on an option
      item.on("click", toggleItemEvent);
    }

    function createDropdownOptions() {
      const selectedOptions = [];
      // For each option, create a li
      if(originalSelectTag.find("optgroup").length) {
        // set placeholder
        newDropdownText.find(".placeholder").text(initialSelectedOption.text());

        originalSelectTag.find("optgroup").each(function () {
          const optgroup = $(this);

          const item = $(
            `<li class="optgroup">${optgroup.attr('label')}</li>`
          );
          newDropdownOptions.append(item);

          optgroup.find("option").each(function () {
            const option = $(this);

            const isPlaceholder = option.hasClass("placeholder"); //? Sould this be hardcoded

            if (!isPlaceholder) {
              const item = $(
                `<li><span>${option.text()}</span></li>`
              );

              item.attr("data-dropdown-value", option.val());

              // If this is the initial selected option, add the selected attribute
              if (option.attr("selected")) {
                selectedOptions.push(item);
              }

              setupDropdownItemEvents(item);

              newDropdownOptions.append(item);
            } else {
              newDropdownText.find(".placeholder").text(initialSelectedOption.text());
            }
          });
        });
      } else {
        originalSelectTag.find("option").each(function () {
          const option = $(this);

          const isPlaceholder = option.hasClass("placeholder"); //? Sould this be hardcoded

          if (!isPlaceholder) {
            const item = $(
              `<li><span>${option.text()}</span></li>`
            );

            item.attr("data-dropdown-value", option.val());

            // If this is the initial selected option, add the selected attribute
            if (option.attr("selected")) {
              selectedOptions.push(item);
            }

            setupDropdownItemEvents(item);

            newDropdownOptions.append(item);
          } else {
            newDropdownText.find(".placeholder").text(initialSelectedOption.text());
          }
        });
      }

      selectedOptions.forEach(toggleItem);
    }

    function copyStyles() {
      // Get a reference to the source and target elements
      var source = originalSelectTag;
      var target = newDropdownText;

      target.addClass(source.attr("class"));
    }
  }

  function closeAllDropdowns() {
    // Find elements with the data-dropdown-open attribute
    $("[data-dropdown-open]").each(function () {
      var jQueryelement = $(this);

      // Check if the click event is not within the current element or its descendants
      if (
        !jQueryelement.is(event.target) &&
        jQueryelement.has(event.target).length === 0
      ) {
        // Set the attribute to "false" when clicking outside
        jQueryelement.attr("data-dropdown-open", "false");
      }
    });
  }

  // Logic that closes the dropdown if the user clicks outside of it
  $(document).on("click", function (event) {
    closeAllDropdowns();
  });

  $("select").each(function (index) {
    var elementToReplace = $(this);

    const newDropdown = createNewDropdown(elementToReplace, index);

    elementToReplace.after(newDropdown);
    elementToReplace.hide();
  });


})(jQuery);
